import React, {useEffect, useMemo, useState} from 'react';
import styles from './TotalResult.module.css';

const sampleData = {
  items: [
    { Party: "NDA", Lead: "0" },
    { Party: "INDIA", Lead: "0" },
    { Party: "Others", Lead: "0" }
  ]
};

const TotalResult = () => {
  const [results, setResults] = useState({
    parties: [],
    totalSeats: 0,
    loading: true,
    error: null
  })

  useEffect(() => {
    const fetchResults = async () => {
      try {
        const now = new Date();
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const timestamp = `${hours}${minutes}`;

        const response = await fetch(`/result/ACF2021/json/element354.json?t=${timestamp}`, {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0'
          }
        });

        if (!response.ok) {
          throw new Error('Failed to fetch results');
        }

        const data = await response.json();
        processData(data);

      } catch (error) {
        console.warn('Error fetching live data, using sample data:', error);
        processData(sampleData);
      }
    };

    const processData = (data) => {
      try {
        const parties = data.items.map(item => ({
          name: item.Party,
          seats: parseInt(item.Lead, 10) || 0,
          className: item.Party.toLowerCase()
        }));

        const totalSeats = parties.reduce((sum, party) => sum + party.seats, 0);

        setResults({
          parties,
          totalSeats,
          loading: false,
          error: null
        });
      } catch (error) {
        console.error('Error processing data:', error);
        setResults(prev => ({
          ...prev,
          loading: false,
          error: 'Error processing election data'
        }));
      }
    };

    fetchResults();
  }, []);

  const sortedParties = useMemo(() => {
    return [...results.parties].sort((a, b) => b.seats - a.seats);
  }, [results.parties]);

  if (results.loading) {
    return <div className={styles.totalResult}>Loading...</div>;
  }

  if (results.error) {
    return <div className={styles.totalResult}>{results.error}</div>
  }

  return (
    <>
      <h3>TOTAL</h3>
      <div className={styles.totalResult}>
        <div className={styles.trHead}>
          <h1 className={styles.title}>BIHAR</h1>
          <span>{results.totalSeats}/243</span>
        </div>
        <div className={styles.totals}>
          {sortedParties.map((party, index) => (
            <div
              key={index}
              className={`${styles.total} ${styles[party.className]}`}
              style={{
                '--animation-delay': `${index * 0.3}s`,
                '--animation-duration': '6s'
              }}
            >
              <h2 className={`${styles.count} ${styles[party.className]}`}>{party.seats}</h2>
              <span className={styles.label}>{party.name}</span>
            </div>
            /*<div key={index} className={`${styles.total} ${styles[party.className]}`}>
              <h2 className={`${styles.count} ${styles[party.className]}`}>{party.seats}</h2>
              <span className={styles.label}>{party.name}</span>
            </div>*/
          ))}
        </div>
        <div className={styles.prevResult}>
          <div className={styles.prevResIn}>
            <span>2020</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="6" height="7" viewBox="0 0 6 7" fill="none">
              <path d="M6 3.46411L-3.26266e-07 6.92821L-2.34249e-08 9.51289e-06L6 3.46411Z" fill="#F81521"/>
            </svg>
            <div>
              <span className={styles.nda}>NDA 125</span> | <span className={styles.india}>INDIA 110</span> | <span className={styles.others}>OTH 8</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TotalResult;
